import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { CreateChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/create-charge-point.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useCreateChargePointContext } from '../../charge-point.context';
import { ChargePointCreateFormStep1Controller } from '../charge-point-create-form-step-1/charge-point-create-form-step-1.controller';
import { ChargePointCreateFormStep2Controller } from '../charge-point-create-form-step-2/charge-point-create-form-step-2.controller';
import { ChargePointCreateFormStep3Controller } from '../charge-point-create-form-step-3/charge-point-create-form-step-3.controller';

export interface ChargePointCreateFormControllerProps {
  onError: SubmitErrorHandler<CreateChargePointModel>;
  onSubmit: SubmitHandlerWithDirtyFields<CreateChargePointModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const ChargePointCreateFormController = (
  props: ChargePointCreateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const { t } = useTranslation();
  const data = useCreateChargePointContext();

  return (
    <MultiStepFormProvider<CreateChargePointModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          title: t('$.charge-point-create.step-1.title'),
          iconName: 'electric-terminal-3',
          fields: [
            'identity',
            'authenticationLayer',
            'authorizedIps',
            'name',
            'isLocked',
            'ocppAuthenticationPassword',
            'customerId',
            'networkId',
          ],
          component: <ChargePointCreateFormStep1Controller />,
        },
        {
          title: t('$.charge-point-create.step-2.title'),
          iconName: 'electric-terminal',
          fields: ['channels'],
          component: <ChargePointCreateFormStep2Controller />,
        },
        {
          title: t('$.charge-point-create.step-3.title'),
          iconName: 'info-circle',
          fields: [
            'parkingRestrictions',
            'capabilities',
            'tariffId',
            'locationId',
          ],
          component: <ChargePointCreateFormStep3Controller />,
        },
      ]}
    />
  );
};
